module.exports = __webpack_public_path__ + "static/bg-035cdbf9be734061db75d6b91147e630.png";